import React, { FC, PropsWithChildren } from 'react';
import { OptionLabelProps } from './types';
import { FormControl, FormHelperText } from '@chakra-ui/react';
import { Typography } from '../Typography';
import { IconButton } from '../IconButton';

type OptionLabelPropsWithChildren = PropsWithChildren<OptionLabelProps>;

export const OptionLabel: FC<OptionLabelPropsWithChildren> = ({ label, helpText, tooltip, children }) => {
  return (
    <>
      <Typography as="span" textAlign="center" w="full">
        {label}
        {tooltip && (
          <IconButton
            icon={{ iconName: 'info-circle', prefix: 'far' }}
            isRound={true}
            m={-1}
            ms={1}
            size={'2xs'}
            tooltip={{
              content: tooltip.content,
              placement: 'top',
            }}
            verticalAlign={'baseline'}
            variant="ghost"
            colorScheme="info"
          />
        )}
      </Typography>
      {helpText && (
        <FormControl>
          <FormHelperText fontSize="sm">{helpText}</FormHelperText>
        </FormControl>
      )}
      {children}
    </>
  );
};

OptionLabel.displayName = 'OptionLabel';
